import PropTypes from 'prop-types'

/**
 * @typedef {Object} CameraIoSubscription
 * @property {string} [ioType]       - Which Input or Outpu type is used.
 * @property {string} [ioChannel]    - I/O channel number.
 * @property {string} [ioIndex]      - I/O index.
 * @property {string} [eventWhenOn]  - Create video event when io is on.
 * @property {string} [eventWhenOff] - Create video event when io is off.
 */
export const cameraIoSubscriptionPropType = PropTypes.shape({
    ioType: PropTypes.string,
    ioChannel: PropTypes.number,
    ioIndex: PropTypes.number,
    eventWhenOn: PropTypes.bool,
    eventWhenOff: PropTypes.bool
})
